module.exports = __webpack_public_path__ + "img/presscoins-own-coin-white.aefcd181.png";